function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThinkBubble({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 321.22137,
    height: 169.84712,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-139.38928,-524.58148)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.3244791,0,0,4.8627328,-1691.137,-342.319)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7a7a7a",
      filter: "url(#filter3807)"
    },
    d: "m 235.8,181.88 c -1.7066,0.0803 -3.1692,1.002 -4.375,3.3438 -3.8801,-1.4964 -6.4668,0.81929 -5.875,4.5 -2.4876,1.2081 -3.632,4.9801 2,6.125 -0.6413,1.9221 0.26638,3.3279 2.625,4.25 0.56657,1.8185 1.4093,3.195 3.625,2.375 2.0806,1.9332 4.5028,1.8168 7.25,-0.25 2.6576,0.82051 5.3059,0.7102 7.125,-2.625 1.8772,-0.0869 4.8647,0.11903 4.375,-4 1.7299,-1.1414 3.5542,-2.695 1.25,-5 0.17155,-2.6497 -0.64958,-5.572 -4.25,-5.75 -2.4677,-3.379 -5.5334,-3.4378 -9.375,-1.875 -1.5629,-0.7155 -3.0476,-1.1562 -4.375,-1.0938 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7af0f8",
      stroke: "#000000",
      strokeWidth: "0.26148px"
    },
    d: "m 235.94,179.38 c -1.7066,0.0803 -3.1692,1.002 -4.375,3.3438 -3.8801,-1.4964 -6.4668,0.81929 -5.875,4.5 -2.4876,1.2081 -3.632,4.9801 2,6.125 -0.6413,1.9221 0.26638,3.3279 2.625,4.25 0.56657,1.8185 1.4093,3.195 3.625,2.375 2.0806,1.9332 4.5028,1.8168 7.25,-0.25 2.6576,0.82051 5.3059,0.7102 7.125,-2.625 1.8772,-0.0869 4.8647,0.11903 4.375,-4 1.7299,-1.1414 3.5542,-2.695 1.25,-5 0.17155,-2.6497 -0.64958,-5.572 -4.25,-5.75 -2.4677,-3.379 -5.5334,-3.4378 -9.375,-1.875 -1.5629,-0.7155 -3.0476,-1.1562 -4.375,-1.0938 z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "matrix(3.8244,0,0,3.8244,-614.12022,-121.88518)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7a7a7a",
      filter: "url(#filter3807-0)"
    },
    d: "m 229.1125,202.849 c -0.93198,0 -1.6875,0.55964 -1.6875,1.25 0,0.69036 0.75552,1.25 1.6875,1.25 0.93198,0 1.6875,-0.55964 1.6875,-1.25 0,-0.69036 -0.75552,-1.25 -1.6875,-1.25 z m -2.6875,3.25 c -0.65584,0 -1.1875,0.40556 -1.1875,0.875 0,0.46944 0.53166,0.84375 1.1875,0.84375 0.65584,0 1.1875,-0.37431 1.1875,-0.84375 0,-0.46944 -0.53166,-0.875 -1.1875,-0.875 z m -3.0312,3.0938 c -0.30376,0 -0.53125,0.15597 -0.53125,0.34375 0,0.18778 0.22749,0.3125 0.53125,0.3125 0.30376,0 0.5625,-0.12472 0.5625,-0.3125 0,-0.18778 -0.25874,-0.34375 -0.5625,-0.34375 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3633-6-3",
    style: {
      fill: "#7af0f8",
      stroke: "#000000",
      strokeWidth: "0.26148px"
    },
    d: "m 229.2525,200.349 c -0.93198,0 -1.6875,0.55964 -1.6875,1.25 0,0.69036 0.75552,1.25 1.6875,1.25 0.93198,0 1.6875,-0.55964 1.6875,-1.25 0,-0.69036 -0.75552,-1.25 -1.6875,-1.25 z m -2.6875,3.25 c -0.65584,0 -1.1875,0.40556 -1.1875,0.875 0,0.46944 0.53166,0.84375 1.1875,0.84375 0.65584,0 1.1875,-0.37431 1.1875,-0.84375 0,-0.46944 -0.53166,-0.875 -1.1875,-0.875 z m -3.0312,3.0938 c -0.30376,0 -0.53125,0.15597 -0.53125,0.34375 0,0.18778 0.22749,0.3125 0.53125,0.3125 0.30376,0 0.5625,-0.12472 0.5625,-0.3125 0,-0.18778 -0.25874,-0.34375 -0.5625,-0.34375 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinkBubble);
export default __webpack_public_path__ + "static/media/think-bubble.f1508272ddd853ca47fb5980dc096045.svg";
export { ForwardRef as ReactComponent };